module.exports = __webpack_public_path__ + "static/img/jingwai-banner@2x.52e8451.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mainindex/jingwai-banner@2x.jpg
// module id = 931
// module chunks = 0